// 渠道
export const Channel = {
    // 系统分享
    SYSTEM: 'system',
    // reddit
    REDDIT: 'reddit',
    // fb
    FACEBOOK: 'facebook',
    // telegram
    TELEGRAM: 'telegram',
    // 小红书
    XIAOHONGSHU: 'xiaohongshu',
    // tw
    TWITTER: 'twitter',
    // ins
    INSTAGRAM: 'instagram'
};

// 市场，编辑器选择，与事件上报相关
export const ShareEventMarket = {
    HK: '1',
    SG: '2',
    MY: '3',
    US: '4',
    JP: '5',
    CA: '6',
    AU: '7'
};

// 市场选项
export const ShareEventMarketOption = Object.entries(ShareEventMarket).map(([key, value]) => ({
    value,
    label: key
}));
